import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post } from './agent';

const ledger =
  (ledgerUrl) =>
  (id = '') => {
    const url = _([ledgerUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      post: (data) => post(url, data),
      patch: (data) => patch(url, data),
      delete: () => del(url),
      batch: {
        create: (data) => post(url.concat('/batch/create'), data),
      },
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
    };
  };

const projectMembers =
  (membersUrl) =>
  (id = '') => {
    const url = _([membersUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      assignable: () => get(url.concat('/assignable')),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      upsert: (body) => (id ? patch : post)(url, body),
      delete: () => del(url),
      batch: {
        add: (data) => post(url.concat('/batch'), data),
      },
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
    };
  };

const projectRoles =
  (rolesUrl) =>
  (id = '') => {
    const url = _([rolesUrl, id]).compact().join('/');

    return {
      get: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      post: (body) => post(url, body),
      patch: (body) => patch(url, body),
      delete: () => del(url),
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
      hasDependencies: () => get(url.concat('/has-dependencies')),
      batch: {
        add: (body) => post(url.concat('/batch/add'), body),
      },
    };
  };

const projectSettings =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'projects', id, 'settings']).compact().join('/');

    return {
      budget: () => get(url.concat('/budget')),
      budgetDashboard: () => get(url.concat('/budget/dashboard')),
      monthlyBudget: () => get(url.concat('/monthly-budget')),
      monthlyBudgetDashboard: () => get(url.concat('/monthly-budget/dashboard')),
      overview: () => get(url.concat('/overview')),
      updateOverview: (body) => patch(url.concat('/overview'), body),
      revenueRecognitionSummary: () => get(url.concat('/revenue-recognition/summary')),
      updateBudget: (body) => patch(url.concat('/budget'), body),
      updateMonthlyBudget: (body) => patch(url.concat('/monthly-budget'), body),
      fixedFeeRevenue: () => get(url.concat('/revenue-recognition/fixed-fee-revenue')),
      recognizeRemainingRevenue: (body) => post(url.concat('/revenue-recognition/recognize-remaining'), body),
      projectRoles: projectRoles(url.concat('/project-roles')),
      members: projectMembers(url.concat('/project-members')),
      projectExpenses: ledger(url.concat('/project-expenses')),
      invoiceMilestones: ledger(url.concat('/invoice-milestones')),
      otherItems: ledger(url.concat('/other-items')),
      prepayments: ledger(url.concat('/prepayments')),
      products: ledger(url.concat('/product-items')),
      serviceItems: ledger(url.concat('/service-items')),
      revenueAdjustments: ledger(url.concat('/revenue-adjustments')),
      revenueRecognitionEntries: ledger(url.concat('/revenue-recognition-entries')),
      revenueRecognitionGenerateContext: () => get(url.concat('/revenue-recognition/generate-context')),
    };
  };

export default projectSettings;
